import { mergeQueryParams } from '@/utils/merge-query-params';
import { Params } from '@/utils/types';
import { useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { useDebouncedCallback } from 'use-debounce';

type ResponseValue = {
	handleFilterChange: (value: string) => void;
};

export default function useTableFilter(): ResponseValue {
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();

	const setDebouncedQueryParam = useDebouncedCallback(value => {
		if (!value) {
			const queryString = mergeQueryParams(searchParams, {
				[Params.search]: undefined,
				[Params.page]: 1
			});

			navigate(`?${queryString}`);
			return;
		}
		const queryString = mergeQueryParams(searchParams, {
			[Params.search]: value,
			[Params.page]: 1
		});

		navigate(`?${queryString.toString()}`);
	}, 500);

	const handleFilterChange = useCallback(
		(value: string) => {
			setDebouncedQueryParam(value);
		},
		[setDebouncedQueryParam]
	);

	return { handleFilterChange };
}
